import { Popper, PopperProps, Typography } from "@mui/material";
import { useItemTooltip, UseItemTooltipReturnValue } from "@mui/x-charts";
import {
    generateVirtualElement,
    useMouseTracker,
} from "@mui/x-charts/ChartsTooltip/utils";
import { useTranslation } from "react-i18next";

import { INITIAL_YEAR, ReductionProposal } from "legacyNext/types";

import { S } from "../reduction-analysis.styles";

type Props = PopperProps & {
    proposals: Array<
        Pick<ReductionProposal, "id" | "startYear" | "description" | "title">
    >;
};

export const ChartItemTooltip = (props: Props) => {
    const { proposals } = props;
    const tooltipData: UseItemTooltipReturnValue<"line"> | null =
        useItemTooltip() as any;
    const mousePosition = useMouseTracker();
    const dataIndex = tooltipData?.identifier.dataIndex;
    const { t } = useTranslation();

    if (!tooltipData || !mousePosition || !dataIndex) {
        return null;
    }

    const year = INITIAL_YEAR + dataIndex;
    const enabled = proposals.filter((p) => p.startYear === year);

    return (
        <Popper
            {...props}
            sx={{
                pointerEvents: "none",
                zIndex: (theme) => theme.zIndex.modal,
            }}
            placement="top"
            anchorEl={generateVirtualElement(mousePosition)}
        >
            <S.TooltipPaper sx={{ width: 300 }}>
                <Typography color="primary" fontWeight="bold">
                    {year} -{" "}
                    {t("legacyNext.initiative", { count: enabled.length })}
                </Typography>
                {enabled.map((p) => (
                    <Typography
                        key={p.id}
                        textOverflow={"ellipsis"}
                        whiteSpace={"nowrap"}
                        overflow={"hidden"}
                        variant="body2"
                    >
                        {`(${p.id}) - ${p.title}`}
                    </Typography>
                ))}
            </S.TooltipPaper>
        </Popper>
    );
};
